import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { ReportsApi } from '../../../api/reports-api';
import { ILegislativeDistrict, ReportHelper } from '../../report-helper';

@Component({
    selector: 'om-project-detail-report',
    templateUrl: './projectDetailReport.html',
    styleUrls: ['../../reports.css', './projectDetailReport.css']
})

export class ProjectDetailReportComponent implements OnInit {

    private projectId: string;
    reportData: any;
    private readonly districtInformation: {
        congress: ILegislativeDistrict;
        senate: ILegislativeDistrict;
        house: ILegislativeDistrict;
    } = <any>{};
    isGenerating = false;
    error = false;
    errorMessage = this.reportHelper.reportErrorMessages.noReportData;

    constructor(private readonly reportsApi: ReportsApi,
                private readonly reportHelper: ReportHelper,
                private readonly route: ActivatedRoute,
                titleService: Title) {
        titleService.setTitle(titleService.getTitle() + ' : Project Detail Report');
    }

    async ngOnInit() {
        this.isGenerating = true;
        this.route.paramMap.subscribe(x => {
            this.projectId = JSON.parse(window.localStorage.getItem(x.get('id'))).projectId;
            this.loadReport();
        });
    }

    private async loadReport() {
        this.isGenerating = true;
        await this.reportsApi.getProjectDetailReportData(this.projectId).then((reportData) => {
            this.reportData = reportData;
        }, (error) => {
            this.isGenerating = false;
            this.error = true;
        });
        await this.getDistrictInformation(this.reportData.projectDetail);
        this.isGenerating = false;
    }

    private async getDistrictInformation(data: any) {
        this.districtInformation.congress = await this.reportHelper.getCongressionalDistrictByName(parseInt(data.congresS_DISTRICTS, 10));
        this.districtInformation.senate = await this.reportHelper.getSenateDistrictByName(parseInt(data.senatE_DISTRICTS, 10));
        this.districtInformation.house = await this.reportHelper.getHouseDistrictByName(parseInt(data.housE_DISTRICTS, 10));
    }
}
